import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRegistration } from "@/context/RegistrationContext";

/**
 * Keeps ?app=<applicationNumber> in the URL in sync with the registration state.
 * On mount: if URL has ?app= and state is empty, seed state → triggers backend hydration.
 * On state change: if state has an app number but the URL doesn't, append it to the URL
 * (via replaceState, no navigation). Result: refresh preserves progress without localStorage.
 */
export const AppNoSync = () => {
  const loc = useLocation();
  const nav = useNavigate();
  const { state, update } = useRegistration();

  // Pull ?app= from the URL on every route change → hydrate state.
  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const urlApp = params.get("app");
    if (urlApp && !state.applicationNumber) {
      update({ applicationNumber: urlApp });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.pathname, loc.search]);

  // Push state.applicationNumber → URL (replace, don't push).
  useEffect(() => {
    if (!state.applicationNumber) return;
    // Only add on the flow pages — never on public / admin / display screens.
    const target = loc.pathname;
    if (!/^\/(otp|register|success|dashboard)/.test(target)) return;
    const params = new URLSearchParams(loc.search);
    if (params.get("app") === state.applicationNumber) return;
    params.set("app", state.applicationNumber);
    nav(`${target}?${params.toString()}`, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.applicationNumber, loc.pathname]);

  return null;
};
